import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isUndefined } from 'lodash-es';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { LeaseDealsModel, LeaseDealsPaths } from 'client/data/models/lease-deals';
import { LoadingOverlay } from 'site-modules/shared/components/loading-spinner/loading-overlay';

export function LoadingUI({ leaseDealsData = undefined, filters = undefined, className = null }) {
  const isLoading = isUndefined(leaseDealsData) || isUndefined(filters);

  return <LoadingOverlay className={classnames(className, { 'd-none': !isLoading })} />;
}
LoadingUI.propTypes = {
  leaseDealsData: PropTypes.shape({}),
  filters: PropTypes.shape({}),
  className: PropTypes.string,
};

LoadingUI.displayName = 'LoadingUI';

export const Loading = connectToModel(LoadingUI, {
  leaseDealsData: bindToPath(LeaseDealsPaths.getLeaseDealsPath(), LeaseDealsModel, null, false),
  filters: bindToPath(LeaseDealsPaths.getFiltersPath(), LeaseDealsModel, null, false),
});
